import { uiSelector } from 'common/reducers/ui';
import createRootSelector from 'common/apps/core/selectors/createRootSelector';
import MEDIA_BREAKPOINTS from 'common/constants/mediaBreakpoints';

export const uiBreakpointRootSelector = createRootSelector(
  uiSelector,
  ({ breakpoint }) => breakpoint,
);

export const isSmallMobileRootSelector = createRootSelector(
  uiBreakpointRootSelector,
  (breakpoint) => breakpoint < MEDIA_BREAKPOINTS.breakpointSmallMobile,
);

export const isMobileRootSelector = createRootSelector(
  uiBreakpointRootSelector,
  (breakpoint) => breakpoint < MEDIA_BREAKPOINTS.breakpointMobile,
);

export const isWideMobileRootSelector = createRootSelector(
  uiBreakpointRootSelector,
  (breakpoint) => breakpoint < MEDIA_BREAKPOINTS.breakpointWideMobile,
);

export const isTabletRootSelector = createRootSelector(
  uiBreakpointRootSelector,
  (breakpoint) => breakpoint < MEDIA_BREAKPOINTS.breakpointTablet,
);

export const isOnLineSelector = createRootSelector(
  uiSelector,
  ({ isOnLine }) => isOnLine,
);
